var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import makeStyles from "@mui/styles/makeStyles";
export default makeStyles(function (_a) {
    var _b = _a.palette, background = _b.background, grey = _b.grey, spacing = _a.spacing, pxToRem = _a.typography.pxToRem, tooltip = _a.zIndex.tooltip;
    // arrow box css adapted from http://www.cssarrowplease.com/
    var arrowCommonCSS = {
        border: "solid transparent",
        bottom: "100%",
        content: "' '",
        height: 0,
        right: spacing(8),
        width: 0,
    };
    return {
        popper: {
            zIndex: tooltip,
            maxWidth: "90%",
        },
        button: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        paper: {
            border: "".concat(pxToRem(1), " solid ").concat(grey[500]),
            marginTop: spacing(1.5),
            padding: spacing(1, 1, 2, 2.5),
            position: "relative",
            "&:after": __assign(__assign({}, arrowCommonCSS), { borderColor: "transparent transparent ".concat(background.paper, " transparent"), borderWidth: pxToRem(10), marginRight: pxToRem(-10), position: "absolute" }),
            "&:before": __assign(__assign({}, arrowCommonCSS), { borderBottomColor: grey[500], borderWidth: pxToRem(11), marginRight: pxToRem(-11), position: "absolute" }),
        },
    };
});
//# sourceMappingURL=useStyles.js.map